<template>
  <ul class="lines" :class="{ comparador }">
    <li v-for="(item, index) in data" :key="item.left" :class="{ inactive: selected && item.left != selected.key }">
      <button class="reset" :class="{ base: !selectable }" @click="click({
        ...item,
        index
      })">
        <img class="avatar" v-if="item.image" src="item.image"/>
        <span class="title full-left">{{item.left}} <span v-if="item.note"> *</span></span>
        <span v-if="item.right" class="description full-right">{{item.right}}</span>
        <span class="percentage">
          <span v-if="!comparador" :style="{ background: item.bg, width: percentage(item.value || 0, 0) }" class="bar"/>
          <template v-else>
            <div 
              class="comparador" 
              :class="[ item.value > 0 ? 'more' : 'less' ]"
              :style="{ background: item.bg, width: percentage(variation(item), 0) }" 
            />
            <div class="middle"/>
          </template>
          <div class="value" :class="[ item.value > 0 ? 'positive' : 'negative' ]">
            <span class="val">{{!comparador ? calc(item) : calc(item).replace('%','pp')}}</span>
          </div>
        </span>
      </button>
    </li>
    <button 
        v-if="options" 
        class="primary more" 
        @click="toggle" 
        :data-kpi="$kpis(`see-more_${!comparador ? 'results' : 'variation'}`)"
    >{{!full ? 'Ver Todos' : 'Ver Menos'}}</button>
  </ul>
</template>

<script>
import { percentage, sort } from '@/core/utils'

export default {
    props: {
        items: Array,
        selected: Object,
        selectable: Boolean,
        comparador: Boolean,
        total: {
            default: 10,
            type: Number
        },
        sort: {
            default: 'value',
            type: String
        }
    },
    data: () => ({
        full: false
    }),
    emits: ["change"],
    methods: {
        percentage,
        click(res) {
            this.selectable && this.$emit('change', res);
        },
        calc(item) {
            return `${!this.comparador || !item.value ? '' : item.value > 0 ? '+' : ''}${this.percentage(item.value || 0)}`;
        },
        toggle() {
            this.full = !this.full;
        },
        variation(item) {
            if(!item || !item.value) return 0;
            let value = (`${(parseFloat(item.value || 0))}`.replace('-', '') / 2);
            return value + 1 - parseFloat(value / 100);
        }
    },
    computed: {
        options() {
            if(!this.items) return;
            return this.items.length > this.total
        },
        data() {
            if(!this.items) return;
            let res = sort([
                ...this.items
            ], this.sort, true, true);
            if(!this.full && res.length > this.total) res.length = this.total;
            return res;
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/styles/mixins.scss';
@import '@/styles/variables.scss';

ul.lines {
    li {
        &.inactive {
            @include opacity(.35);
        }
        button {
            width: 100%;
            font-size: 0.8rem;
            margin-bottom: 0;
            .title {
                font-size: 0.7rem;
            }
            .description {
                margin-bottom: 0.1rem;
            }
            .middle {
                height: 100%;
                width: calc(50% - 1px);
                border-right: 2px solid #555;
            }
            .comparador {
                height: 100%;
                background: #aaa;
                position: absolute;
                top: 0;
                bottom: 0;
                &.less {
                    right: 50%;
                }
                &.more {
                    left: 50%;
                }
            }
            .percentage {
                display: block;
                height: 24px;
                position: relative;
                background: var(--base-bar-color);
                clear: both;
                @include radius(2px);
                margin-bottom: 0.65rem;
                color: var(--base-tab-active-color);
                font-size: 0.8rem;
                .bar,
                .value {
                    position: absolute;
                    height: inherit;
                    left: 0;
                    bottom: 0;
                    top: 0;
                    @include radius(2px);
                }
                .bar {
                    width: 0;
                    z-index: 1;
                    background: var(--base-light-alternative-color);
                }
                .value {
                    line-height: 24px;
                    text-align: center;
                    right: 0;
                    z-index: 2;
                    color:var(--base-dark-color);
                    text-shadow: -1px 0 var(--base-white), 0 1px var(--base-white), 1px 0 var(--base-white), 0 -1px var(--base-white);
                    font-weight: 600;
                }
            }
        }
    }
    &.comparador {
        li {
            button {
                margin-bottom: 2rem;
                .avatar {
                    display: none;
                }
                .percentage {
                    height: 12px;
                    .value {
                        .val {
                            font-weight: 500;
                            text-shadow: none;
                        }
                        &.positive {
                            margin-top: 0.5rem;
                            .val {
                                color: green;
                            }
                        }
                        &.negative {
                            margin-top: 0.5rem;
                            .val {
                                color: red;
                            }
                        }
                    }
                }
            }
        }
    }
    .more {
        width: 260px;
    }
}
</style>
